import React from "react";

function TimeSheetIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 17.004 17.004">
      <path
        d="M18.5,10.752A7.752,7.752,0,1,1,10.752,3,7.752,7.752,0,0,1,18.5,10.752Z"
        transform="translate(-2.25 -2.25)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18,9v4.651l3.1,1.55"
        transform="translate(-10.024 -5.149)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { TimeSheetIcon };
